import * as React from "react";

interface LinkButtonProps {
    text: string,
    onClick?: (args: any) => any
}
export const LinkButton = ({ text, onClick }: LinkButtonProps) => {

    return <button onClick={onClick} className="bg-green-600 hover:bg-green-700 w-full h-12 flex place-content-center place-items-center rounded text-white font-bold">{text}</button>
}